module.exports = __webpack_public_path__ + "static/img_5-198873d79e68501bebee45ec2593df89.png";